// extracted by mini-css-extract-plugin
export default {"BonusGames":"BonusGames_BonusGames__sM-Ya"};